export default __webpack_public_path__ + "static/media/CGAS.330cc4a2.svg";